import axiosInstance from "../Interceptors/axiosInstance.jsx";

const BASE = "homepage/hero-banners";

export const getHeroBannersList = async () => {
  return await axiosInstance.get(`${BASE}/getlist`);
};

export const getHeroBannerById = async (id) => {
  const response = await axiosInstance.get(`${BASE}/get/${id}`);
  return response.data?.result ?? response.data;
};

export const addHeroBanner = async (formData) => {
  return await axiosInstance.post(`${BASE}/add`, formData);
};

export const updateHeroBanner = async (formData) => {
  return await axiosInstance.put(`${BASE}/update`, formData);
};

export const deleteHeroBanner = async (id) => {
  return await axiosInstance.delete(`${BASE}/delete/${id}`);
};
